import { AppRoutes } from "./routers/AppRoutes"
import { Providers } from "./Providers"

import "@mantine/core/styles.css"
import "@mantine/carousel/styles.css"

const App = () => {
	return (
		<Providers>
			<AppRoutes />
		</Providers>
	)
}

export default App
